module.exports = __webpack_public_path__ + "static/media/facebook-like-thumbs-up-round-icon-vector-logo.2a77fc7f.svg";